import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {KMDGameMode} from "../server/KMDGameMode";

export class KMDCFSIntroRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return ((KennethMustDie.model.data.mode.indexOf(KMDGameMode.NORMAL) > -1 || KennethMustDie.model.data.mode === KMDGameMode.FREESPIN || KennethMustDie.model.data.mode === KMDGameMode.FREESPIN_AVALANCHE) && (KennethMustDie.model.data.nextMode === KMDGameMode.FREESPIN_COOL));
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        KennethMustDie.cfsIntro.showIntro(() => controller.finish());
    }
}